import userDeviceService from '../user/userDeviceService';

// All names should be in upper case
const DEVICES_WITHOUT_INITIAL_PAIRING_PROBLEM_ON_WINDOWS = [
    'DUO',
    'MY IQOS 2.4+',
    'IQOS ORIGINALS DUO',
    'IQOS 3 MULTI',
    'MY IQOS 3',
    'VEEV',
];
const PAIRING_DElAY_MS = 4000;

export const getPairingDelay = ({deviceName, retryNumber, isPairingDelayOnWindowsEnabled}) => {
    const MAX_MULTIPLIER = 2;

    if (retryNumber > MAX_MULTIPLIER) return MAX_MULTIPLIER * PAIRING_DElAY_MS;
    if (retryNumber) return retryNumber * PAIRING_DElAY_MS;

    const firstTryPairingDelay = getFirstTryPairingDelay(deviceName, isPairingDelayOnWindowsEnabled);

    if (firstTryPairingDelay) return firstTryPairingDelay;

    return 0;
};

const getFirstTryPairingDelay = (deviceName, isPairingDelayOnWindowsEnabled) => {
    const isWindows = userDeviceService.isDesktopWindows();
    const isDelayRequiredForDevice = !DEVICES_WITHOUT_INITIAL_PAIRING_PROBLEM_ON_WINDOWS.includes(
        deviceName.toUpperCase()
    );
    const isInitialPairingDelayEnabled = isWindows && isPairingDelayOnWindowsEnabled && isDelayRequiredForDevice;

    if (isInitialPairingDelayEnabled) return PAIRING_DElAY_MS;
};
